import {Context, createContext} from 'solid-js'
import {ToastProviderBehavior} from './ToastProvider'
import {ToastProps} from './Toast'

export const ToastContext: Context<ToastProviderBehavior> = createContext({
    show: (toast: ToastProps) => undefined,
})
